import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const ON_EVENT_COST_BREAKDOWN_MODAL_OPEN = "onEventCostBreakdownModalOpen";

export const REFRESH_SUMMARY = "refreshSummary";
